import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { Command, CommandBase } from '../../../core/model/command';
import { mailCommand } from '../../model/const/command';
import { MailService } from '../data/mail.service';
import { MessageService } from '../../../core/service/message.service';
import { NativeWindowService } from '../../../core/service/native-window.service';
import { Observable } from 'rxjs';

@Injectable()
export class PreviewMailCommandHandler implements ICommandHandler {
  constructor(
    private _dataService: MailService,
    private _messageService: MessageService,
    private _nativeWindow: NativeWindowService
  ) {}

  canExecute(command: CommandBase): boolean {
    return command.id == mailCommand.preview;
  }
  execute(command: CommandBase): Observable<void> {
    if (command instanceof Command) {
      return this._dataService.preview(command.context.id).pipe(
        map(
          res => this._nativeWindow.openFile(res),
          error => this._messageService.showError(error)
        )
      );
    }
  }
}
